import React from 'react'
import image from '../../../assets/homepage_pro8.png'
const LowerBannerThree = () => {
    return (
        <>
            <div className="cate-bx3 common mr-1">
                <h3>
                    CCTV Camera <span>is available</span>
                </h3>
                <a href="#" className="btn-buy">
                    TRY IT NOW
                </a>
                <div className="text-right">
                    <img className="img-fluid" src={image} alt="" />
                </div>
            </div>

        </>
    )
}

export default LowerBannerThree